'use strict';

import {
  classes,
  addClassToElement,
  removeClassToElement
} from '@jspartials/class-list-utils';
import { listenDOMEvent } from '@jspartials/dom-api-utils';
import { setCookie } from '@jspartials/cookie-utils';
import Modal from '@jsclasses/modal-class';

// CONSTANTS
const loadingGDPR = new CustomEvent('cartActionProcessing');
const loadedGDPR = new CustomEvent('cartActionProcessed');
const receiveCommercialInformationFromBrand =
  'receiveCommercialInformationFromBrand';
const privacyPolicyTermConditions = 'privacyPolicyTermConditions';
const COOKIE_KEY = 'HW_allow_privacy_policy';

const selector = {
  gdprModal: 'js-cart__gdpr-modal',
  gdprModalId: 'GDPRConsentModal',
  hiddenType: 'hidden',
  disabledGdprButton: 'hw-cart__disabled-gdpr',
  gdprForm: '#gdpr_form',
  cartFormCheckout: '#cartFormCheckout',
  gdprConfirmationButton: '.js-cart__gdpr-confirmation-btn',
  gdprConsentAllowAllInput: '.js-cart__gdpr_consent_allow_all_input',
  gdprDisallowButton: '.js-cart__gdpr-disallow-btn',
  cartCheckoutButton: '.js-cart__checkout-button',
  cartGdprMainCheckbox: '.js-cart__main-checkbox'
};

// VARIABLES
var staticGdprModal;
var cartFormCheckout;
var gdprFormInputs;
var gdrpModals = [];
var modalGDPR = null;

function handleGdprFormSubmit() {
  document.dispatchEvent(loadingGDPR);
  goToCheckout();
  document.dispatchEvent(loadedGDPR);
}

function gtmEventOpenGdprPopup() {
  var dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: 'popinViewCart',
    category: 'open',
    action: 'view',
    label: 'viewNewRules'
  });
}

function getCookieGDPR() {
  var keyValue = document.cookie.match(
    '(^|;) ?' + COOKIE_KEY + '=([^;]*)(;|$)'
  );
  return keyValue ? window.atob(keyValue[2]) : null;
}
function setCookieGDPR() {
  // Write cookie with the selected locale
  var date = new Date();
  date.setTime(date.getTime() + 31536000000); // Set the max age in milliseconds; 31536000 seconds / 365 days / 1 year

  var inputList = [];

  gdprFormInputs.forEach(function (input) {
    if (input.type === selector.hiddenType) {
      var value = JSON.parse(input.value);

      inputList.push({ id: input.id, value: value });
      return;
    }
    if (input.name === receiveCommercialInformationFromBrand) {
      inputList.push({
        id: input.id,
        value: !input.checked
      });
    } else {
      inputList.push({
        id: input.id,
        value: input.checked
      });
    }
  });

  setCookie(COOKIE_KEY, window.btoa(JSON.stringify(inputList)), date);
}
function manageGdprPopup() {
  if (modalGDPR) {
    modalGDPR.open();
    updateGdprValues();
    gtmEventOpenGdprPopup();
  } else {
    handleGdprFormSubmit();
  }
}

// Converts cookie values into the checkbox values
function updateGdprValues() {
  var inputList = getCookieGDPR();
  gdprFormInputs = document.querySelectorAll(`${selector.gdprForm} input`);

  if (!inputList) {
    return;
  }
  inputList = JSON.parse(inputList);

  // Iterate over the inputs, change the checkboxes according to the cookie and hide the ones that checked
  gdprFormInputs.forEach(function (gdprInput) {
    var cookieOption = inputList.find(function (inputValue) {
      return inputValue.id === gdprInput.getAttribute('id');
    });

    if (cookieOption) {
      var cookieValue = cookieOption.value;

      if (gdprInput.type === selector.hiddenType) {
        gdprInput.value = cookieValue;
      }
      gdprInput.checked = cookieValue;
      if (
        gdprInput.type !== selector.hiddenType &&
        gdprInput.checked === true &&
        gdprInput.name !== receiveCommercialInformationFromBrand
      ) {
        addClassToElement(gdprInput.parentNode, classes.hidden);
      }

      if (
        gdprInput.name === receiveCommercialInformationFromBrand &&
        gdprInput.checked === true
      ) {
        // We need to check this to FALSE even if the cookie is TRUE so that the inverse value is stored as TRUE
        gdprInput.checked = false;
        addClassToElement(gdprInput.parentNode, classes.hidden);
      }
    }
  });
}

function isModalVisible() {
  var cookiesList = getCookieGDPR();
  var gdprInputsBeforeModalCreation =
    Array.from(document.querySelectorAll(`${selector.gdprForm} input`)) || [];
  var show = true;

  if (cookiesList !== null) {
    show = false;
    cookiesList = JSON.parse(cookiesList);

    // Iterate over the cookies list and check if any of the values is false
    cookiesList.every(function (cookieInputValue) {
      var gdprInput = gdprInputsBeforeModalCreation.find(function (inputValue) {
        return cookieInputValue.id === inputValue.getAttribute('id');
      });
      if (gdprInput) {
        if (
          cookieInputValue.value === false &&
          cookieInputValue.id !== privacyPolicyTermConditions
        ) {
          show = true;
          return false; // Breaks the iteration
        }
      }
      return true;
    });
  }
  return show;
}

function initGdprModal() {
  staticGdprModal = document.getElementById(selector.gdprModalId) || null;

  if (staticGdprModal) {
    // Check if the modal should be displayed
    const modalVisibility = isModalVisible();

    if (modalVisibility) {
      gdrpModals = Modal.initElements('gdpr');
      modalGDPR = gdrpModals.find((obj) => obj.id === selector.gdprModal);

      const gdprConfirmationButton = document.querySelector(
        selector.gdprConfirmationButton
      );
      const gdprConsentAllowAllInput = document.querySelector(
        selector.gdprConsentAllowAllInput
      );
      const gdprDisallowButton = document.querySelector(
        selector.gdprDisallowButton
      );
      const gdprFormInputsCheckboxes = document.querySelectorAll(
        `${selector.gdprForm} input[type=checkbox]`
      );

      listenDOMEvent(gdprConfirmationButton, 'click', () => {
        setCookieGDPR();
        handleGdprFormSubmit();
      });
      listenDOMEvent(gdprConsentAllowAllInput, 'change', (e) => {
        const inputChecked = e.target.checked;
        gdprFormInputsCheckboxes.forEach(function (input) {
          if (
            input.name !== receiveCommercialInformationFromBrand &&
            inputChecked
          ) {
            input.checked = true;
            input.dispatchEvent(new Event('change'));
          }
        });
        if (inputChecked) {
          addClassToElement(gdprDisallowButton, classes.hidden);
        } else {
          removeClassToElement(gdprDisallowButton, classes.hidden);
        }
      });
      listenDOMEvent(gdprDisallowButton, 'click', () => {
        var cookiesList = getCookieGDPR();
        if (cookiesList !== null) {
          cookiesList = JSON.parse(cookiesList);
        }
        gdprFormInputsCheckboxes.forEach(function (input) {
          // If the cookie is set, we want to uncheck only the ones that are visible, technically the ones that are visually checked
          if (cookiesList) {
            var cookieOption = cookiesList.find(function (cookieValue) {
              return cookieValue.id === input.getAttribute('id');
            });

            if (cookieOption.value === false) {
              input.checked = false;
            }
          } else {
            input.checked = false;
          }
        });
        setCookieGDPR();
        handleGdprFormSubmit();
      });

      gdprFormInputsCheckboxes.forEach(function (input) {
        listenDOMEvent(input, 'change', () => {
          var isThereAnyChecked = false;

          gdprFormInputsCheckboxes.forEach(function (input) {
            if (input.checked) {
              isThereAnyChecked = true;
            }
          });
          if (isThereAnyChecked) {
            removeClassToElement(
              gdprConfirmationButton,
              selector.disabledGdprButton
            );
          } else {
            addClassToElement(
              gdprConfirmationButton,
              selector.disabledGdprButton
            );
          }
        });
      });
    }

    if (staticGdprModal.getAttribute('data-disabled-locale') === 'true') {
      setCookieGDPR();
    }
  }
}

const goToCheckout = () => {
  if (cartFormCheckout) {
    cartFormCheckout.submit();
  }
};

const showErrorLegalCheckbox = () => {
  if (cartFormCheckout) {
    addClassToElement(cartFormCheckout, classes.has.error);
  }
};

const hideErrorLegalCheckbox = () => {
  if (cartFormCheckout) {
    removeClassToElement(cartFormCheckout, classes.has.error);
  }
};

document.addEventListener('DOMContentLoaded', function () {
  initGdprModal();

  const mainCheckbox = document.querySelector(selector.cartGdprMainCheckbox);
  const checkoutButton = document.querySelector(selector.cartCheckoutButton);

  cartFormCheckout = document.querySelector(selector.cartFormCheckout) || null;

  if (mainCheckbox) {
    listenDOMEvent(mainCheckbox, 'change', function () {
      if (this.checked) {
        hideErrorLegalCheckbox();
      }
    });
  }

  if (checkoutButton) {
    listenDOMEvent(checkoutButton, 'click', (e) => {
      e.preventDefault();

      if (
        staticGdprModal &&
        ((mainCheckbox && mainCheckbox.checked) || !mainCheckbox)
      ) {
        manageGdprPopup();
      } else if (mainCheckbox && !mainCheckbox.checked) {
        showErrorLegalCheckbox();
      } else {
        goToCheckout();
      }
    });
  }
});
